<div class="card">
    <div class="card-header card-header-squirrel">
        <h4>{{this.translate.data['ADDNEWPROJECT'] | translate}}</h4>        
    </div>
    <div class="card-body">
        <form [formGroup]="projectCreationForm" novalidate *ngIf="!isLoading">
            
            <div class="row">
                <div class="col-md-4">
                    <mat-form-field class="example-full-width">
                        <input type="text" matInput placeholder="{{this.translate.data['PROJECTNAME'] | translate}}" formControlName="name" required>
                        <mat-error *ngIf="!projectCreationForm.controls['name'].valid && projectCreationForm.controls['name'].touched"> {{this.translate.data['ERRORALERT'] | translate}} </mat-error>
                    </mat-form-field>
                </div>

            </div>            
           
            <!-- <div class="row">
                <div class="col-md-4">
                    <mat-form-field class="example-full-width">
                        <input matInput placeholder="Latitude" formControlName="latitude" >
                    </mat-form-field>
                </div>
                <div class="col-md-4">
                    <mat-form-field class="example-full-width">
                        <input matInput placeholder="Longitude" formControlName="longitude" >
                    </mat-form-field>
                </div>
            </div>            -->

            <div class="row">
                <div class="col-md-12">
                    <mat-form-field class="example-full-width">
                        <input matInput placeholder="Description" formControlName="description" >
                        <!-- <mat-error *ngIf="!projectCreationForm.controls['description'].valid && projectCreationForm.controls['description'].touched"> {{
                            this.translate.data['ERRORALERT'] | translate}}  </mat-error> -->
                    </mat-form-field>
                </div>
            </div>    
            
            <div class="row">
                <div class="col-md-12">
                    <mat-form-field class="example-full-width" *ngIf="!serverSelected">
                        <input matInput placeholder="Server" formControlName="serverName" [matAutocomplete]="auto">

                        <mat-autocomplete #auto="matAutocomplete"
                            (optionSelected)="optionSelected($event)">
                            <mat-option *ngIf="isLoading" class="is-loading">
                                <mat-spinner diameter="50"></mat-spinner>
                            </mat-option>
                            <ng-container *ngIf="!isLoading">
                                <mat-option *ngFor="let server of servers" [value]="server">
                                    <span><b>{{ server }}</b></span>
                                </mat-option>
                            </ng-container>
                        </mat-autocomplete>
                    </mat-form-field>
                    <a style="color: black" *ngIf="serverSelected">Server: {{serverName}}</a>
                    <!-- <mat-form-field class="example-full-width">
                        <input matInput placeholder="Server" formControlName="serverName" >
                    </mat-form-field> -->
                    <!-- <a class="a-color" *ngIf="serverSelected">Walter</a> -->
                    <!-- <a class="a-color">Walter</a> -->
                </div>
            </div>


            <div class="row">
                <a>
                    <button mat-raised-button class="btn btn-squirrel" style="margin-top: 6px;margin-left: 0px" matTooltip="{{this.translate.data['TOOLTIPCLOSEADDUSERDIALOG'] | translate}}"
                                    (click)="cancel()" >Abbruch</button>
                </a>                                                
                <span style="flex: 1 1 auto"></span>
                <a>
                    <button mat-raised-button class="btn btn-squirrel" style="margin-top: 6px;" matTooltip="{{this.translate.data['ADDNEWPROJECT'] | translate}}"
                                    (click)="add()" >Hinzufügen</button>
                </a>                   
            </div>    
        </form>
    </div>
</div>